import { useEffect, useState } from "react"

function useWindowSize() {
    // Add a hasMounted state to track if component has mounted
    const [hasMounted, setHasMounted] = useState(false)
    const [windowSize, setWindowSize] = useState<{
        width: number
        height: number
    }>({
        width: 0,
        height: 0,
    })

    useEffect(() => {
        setHasMounted(true)
        
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            })
        }

        // Only add event listener on the client
        handleResize()
        window.addEventListener("resize", handleResize)

        return () => window.removeEventListener("resize", handleResize)
    }, [])

    // Calculate these values only on the client side after mounting
    // Default values for server-side rendering
    const defaultValues = {
        width: 0,
        height: 0,
        isMobile: false,
        isTablet: false,
        isTabletOrSmaller: false,
        isDesktop: true // Default to desktop for SSR
    }

    // Return default values for SSR, real values for client
    if (!hasMounted) return defaultValues

    // Only calculate these on the client after mounting
    const isMobile = windowSize.width < 768
    const isTablet = windowSize.width >= 768 && windowSize.width < 1024
    const isDesktop = windowSize.width >= 1024

    return {
        width: windowSize.width,
        height: windowSize.height,
        isMobile,
        isTablet,
        isTabletOrSmaller: windowSize.width < 1024,
        isDesktop,
    }
}

export default useWindowSize
